import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { apiCallGetAccountsDeletionData } from "../../../api/communications-api/get-accounts-deletions-data";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { isDateRangeValid } from "../../../helpers/et3-date-helper";
import { TAccountDeletionData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import i18n from "../../../constants/i18n";
import {
  DELETE_ACCOUNT_HAPPY_REASON,
  DELETE_ACCOUNT_NORMAL_REASON,
  DELETE_ACCOUNT_SAD_REASON,
  USER_ACCOUNT_DELETIO_REASONS_ORDERED
} from "../../../constants/user-profile";
import { reduce } from "et3-type-guards";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class accountDeletionStore {
  accountDeletionsData = observable.box<TAccountDeletionData[]>([]);
  accountsDeletionDataLimit = observable.box<TEt3PickerSingleValue>({
    label: "10",
    value: "10"
  });
  fromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  toDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  setAccountsDeletionDataLimit = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.accountsDeletionDataLimit.set(limit);
    });
  };

  setAccountDeletionsData = (accountDeletionsData: TAccountDeletionData[]) => {
    runInAction(() => {
      this.accountDeletionsData.set(accountDeletionsData);
    });
  };

  getAccountsDeletionData = async () => {
    this.setAccountDeletionsData([]);
    const definedLimit = reducerToZeroIfUndefined(
      parseInt(this.accountsDeletionDataLimit.get().value, 10)
    );

    if (
      !isDateRangeValid({
        fromDate: this.fromDate.get(),
        toDate: this.toDate.get(),
        isLimitedToOneMonth: true
      })
    ) {
      return;
    }
    getCoreUIStore().setIsLoading("COMMUNICATIONS_ACCOUNTS_DELETION", true);
    const accountsDeletionData = await apiCallGetAccountsDeletionData({
      startDate: this.fromDate.get(),
      endDate: this.toDate.get(),
      limit: definedLimit
    });

    getCoreUIStore().setIsLoading("COMMUNICATIONS_ACCOUNTS_DELETION", false);
    const { data, status, code } = accountsDeletionData;
    if (status === "ERROR") {
      return getCorePopUpStore().showAlertMessage(code);
    }
    const accountDeletionsData = data.map((item) => {
      return {
        ...item,
        reasons: i18n.get(USER_ACCOUNT_DELETIO_REASONS_ORDERED[item.reason]),
        ratingEmojis:
          reduce(() => item.ratingState, 0) === 0
            ? DELETE_ACCOUNT_HAPPY_REASON
            : item.ratingState === 1
              ? DELETE_ACCOUNT_NORMAL_REASON
              : DELETE_ACCOUNT_SAD_REASON,
        DELETE_ACCOUNT_SAD_REASON,
        comment: reduce(() => item.comment, "")
      };
    });

    this.setAccountDeletionsData(accountDeletionsData);
  };
}

const getAccountDeletionStore = memoize(
  () => new accountDeletionStore(),
  () => 1
);
export default getAccountDeletionStore;
